module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/zola-logomark-marine-f4b457781de199b5bead21393e7e2874.svg";